var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.PromptDialogComponent, {
    attrs: {
      title: _setup.saveAsZipText,
      isOpened: _setup.openModal,
      formSchema: _setup.saveAsZipDialogFormSchema,
      context: _vm.context,
      formFieldValues: _setup.zipFormData,
    },
    on: { "execute-action": _setup.executeSaveAsZipDialogAction },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }